import { useId } from 'react';
import './Textarea.css';

function Textarea({ label, error, className = '', ...props }) {
  const id = useId();
  return (
    <div className="admin-field">
      {label && <label htmlFor={id}>{label}</label>}
      <textarea id={id} className={`admin-textarea ${className}`.trim()} {...props} />
      {error && <span className="admin-field-error">{error}</span>}
    </div>
  );
}

export default Textarea;
